<div class="container">
  <a
    matMiniFab
    [style.color]="color"
    class="back-button"
    routerLink=".."
    aria-label="Back Button"
  >
    <fa-icon size="lg" [icon]="faArrowLeft"></fa-icon>
  </a>
</div>
